import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import LibraryCard from "@/components/LibraryCard";
import { Link } from "react-router-dom";

export default function Dashboard() {
  const { user } = useAuth();
  const { t } = useLang();
  if (!user) return null;
  const since = user.created_at ? new Date(user.created_at).getFullYear() : "";

  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-24">
      <div className="eyebrow mb-6">{t("dash.eyebrow")}</div>
      <h1 className="font-headline text-5xl md:text-6xl leading-none">{t("dash.welcome")} {user.full_name}.</h1>
      <p className="font-body text-[#3A3A3A] mt-6 max-w-2xl">
        {t("dash.intro")}
      </p>

      <div className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-6">
          <LibraryCard name={user.full_name} memberNumber={user.member_number} since={since} />
          <div className="mt-4 font-ui text-[10px] tracking-[0.25em] uppercase text-[#6C6C6C]">
            The People's Archive Library — Digital Member Card
          </div>
        </div>
        <div className="lg:col-span-6 border border-[#DCDCDC] p-8">
          <div className="eyebrow mb-4">Member Details</div>
          <dl className="divide-y divide-[#DCDCDC]">
            <div className="py-3 flex justify-between font-body">
              <dt className="text-[#6C6C6C]">Name</dt>
              <dd data-testid="member-name">{user.full_name}</dd>
            </div>
            <div className="py-3 flex justify-between font-body">
              <dt className="text-[#6C6C6C]">Email</dt>
              <dd data-testid="member-email">{user.email}</dd>
            </div>
            <div className="py-3 flex justify-between font-body">
              <dt className="text-[#6C6C6C]">Member Number</dt>
              <dd data-testid="member-number">{user.member_number}</dd>
            </div>
            <div className="py-3 flex justify-between font-body">
              <dt className="text-[#6C6C6C]">Member Since</dt>
              <dd>{since}</dd>
            </div>
          </dl>
          <div className="mt-8 flex gap-3">
            <Link to="/library" className="btn-primary" data-testid="dash-visit-library">Visit Library</Link>
            <Link to="/get-involved" className="btn-outline">Get Involved</Link>
          </div>
        </div>
      </div>

      <div className="mt-16 border border-[#DCDCDC] p-8 md:p-10">
        <div className="eyebrow">Coming Soon</div>
        <div className="font-headline text-2xl md:text-3xl mt-3">
          "My Shelf" — save catalog items for later reading.
        </div>
        <p className="font-body text-[#3A3A3A] mt-3 max-w-2xl">
          A private shelf of saved works, exportable in academic citation formats. Rolling out in the
          next release.
        </p>
      </div>
    </div>
  );
}
